<template>
  <byted-layout  v-if="!this.isLoading">
    <template slot="header">
      <div class="login-header">
        <div id="root-common-header"></div>
      </div>
    </template>
    <div class="content-container">
      <carousel-map class="carousel-map-style" :isWhite="this.isWhite"></carousel-map>
      <!-- 在白则不展示登录框 -->
      <div id="login" class="login-style" v-if="!this.isWhite"></div>
      <ad-lessons :learning-path-data="loginData.learning_path_data"></ad-lessons>
      <ad-products></ad-products>
      <help-center :help-data="loginData.help_data"></help-center>
      <courses :new-course-data="loginData.new_course_data"></courses>
      <success-cases></success-cases>
    </div>
    <new-footer></new-footer>
  </byted-layout>
</template>
<script>
  // import NavHeader from 'Src/components/common/new-nav-header/new-nav-header.vue'
  import CarouselMap from 'Src/components/login/carousel-map/carousel-map.vue'
  import AdLessons from 'Src/components/login/ad-lessons/ad-lessons.vue'
  import AdProducts from 'Src/components/login/ad-products/ad-products.vue'
  import HelpCenter from 'Src/components/login/help-center/help-center.vue'
  import Courses from 'Src/components/login/courses/courses.vue'
  import SuccessCases from 'Src/components/login/success-cases/success-cases.vue'
  import NewFooter from 'Src/components/login/new-footer/new-footer.vue'
  import Pages from 'Src/const/pages'
  const dataInfoURL = '/superior/api/dashboard/get_academy_list'
  const isWhiteURL = '/nbs/api/account/login/loginweb/getIsWhite'

  export default {
    data() {
      return {
        loginData: {
          // help_data: {},
          // hot_course_data: {},
          // learning_path_data: {},
          // new_course_data: {}
        },
        // 登陆页是否在白
        isWhite: false,
        // 登陆页是否在加载中
        isLoading: true,
      }
    },
    components: {
      // NavHeader,
      CarouselMap,
      AdLessons,
      AdProducts,
      HelpCenter,
      Courses,
      SuccessCases,
      NewFooter
    },
    async mounted () {
      this.initialLoginData()
      await this.initIsWhite()
      this.initNavigator ()
    },
    methods: {
      initialLoginData () {
        BUI.fetch({
          url: dataInfoURL,
          data: {
          },
          success: resp => {
            if (resp.code === 0 && resp.data) {
              this.loginData = resp.data
            }
          }
        })
        },
        initIsWhite () {
          return new Promise((resolve, reject) => {
              BUI.fetch({
              url: isWhiteURL,
              data: {},
              success: resp => {
                if (resp.code === 0 && resp.data) {
                  this.isWhite = resp.data.enable
                  this.isLoading = false
                  resolve(resp)
                } else {
                  this.isLoading = false
                  reject(resp)
                }
              },
            }).catch(err => {
              this.isLoading = false
              resolve('获取ip白名单失败')
            })
          })
        },
        initNavigator () {
          // 新版导航头配置
          const newNavigatorConf = {
            render_to: '#root-common-header',
            logo_href: '/pages/index.html',
            subtitle: '广告投放平台',
            header_css: {
              container: {
                style: {
                  'min-width': '1200px'
                }
              }
            },
            // 支持未登录首页显示九宫格
            no_login_show_dom: {
              entrance: true,
            },
          }
          if (window.headerInstance && window.headerInstance.methods && window.headerInstance.methods.hasOwnProperty('initOnload')) {
            headerInstance.methods.initOnload({
              render_to: '#root-common-header',
              logo_href: '/pages/index.html',
              container: {
                style: {
                  'min-width': '1200px'
                }
              }
            })
          } else if (window.navigatorInstance && window.navigatorInstance.methods) {
            if (this.isWhite && window.navigatorInstance.methods.hasOwnProperty('initLoginNav')) {
              navigatorInstance.methods.initLoginNav(newNavigatorConf)
            } else if (window.navigatorInstance.methods.hasOwnProperty('initHeader')) {
              navigatorInstance.methods.initHeader(newNavigatorConf)
          }
        }
      }
      // renderEntrances () {
      //   const navSdk = window.navigatorInstance.methods
      //
      //   navSdk.renderNavIconAvatar({ entrance: navSdk.renderEntrance(context) })
      //   navSdk.getChildNodes()
      //   navSdk.otherActions() // 处理其他操作
      //   navSdk.getOpenedAdvs() // 获取 可选账户列表，需要等 renderNavIconAvatar 执行完毕
      // }
    }
  }
</script>
<style lang="scss">
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .byted-layout {
    .layout-body {
      margin-top: 64px;
      .layout-content {
        background-color: #F7F8FA!important;
        .content-container {
          width: 1200px;
          margin: 20px auto 0px;
          font-size: 0;
        }
      }
    }
  }
  .login-header {
    width: 100%;
    background: #0A2140;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    height: 64px;
  }
  #root-common-header {
    width: 1200px;
    margin: 0 auto;
  }
  .carousel-map-style {
    vertical-align: top;
    display: inline-block;
  }
  .login-style {
    display: inline-block;
    margin-left: 20px;
  }

  // 对sdk 进行的修改
  .login-header {
    .navigator-header-container {
      .entrance {
        position: relative;
        margin-left: auto; // 居右
        left: 25px;        // 和登录框对齐git

        .before {
          display: none;
        }
      }

      .sdk-common-nav-login {
        display: none !important;
      }
    }
  }
</style>
